/** @format */

// This is for server-side config only.

// Use prod as default
const prodConfig = require("./production");
const qaConfig = require("./qa");

const envs = {
  qa: qaConfig,
  prod: prodConfig,
  production: prodConfig,
};

const isServer = typeof window === "undefined";
const awsAccount = process.env.APP_ENV || "qa"; // default to development for local dev
const defaultEnv = envs.prod;
const envConfig = envs[awsAccount] || defaultEnv;
const getGatewayUrl = () => {
  return isServer ? "http://localhost:8000" : "";
};
const getUserAgent = () => {
  return isServer ? "" : window.navigator.userAgent;
};

const loadedConfig = {
  environment: awsAccount,
  isProduction: awsAccount === "prod",
  CDN_PREFIX: isServer ? process.env.CDN_PREFIX || "" : window.FARCDN || "",
  GATEWAY_URL: getGatewayUrl(),
  projectRoot: process.cwd(),
  awsAccount,
  USER_AGENT: getUserAgent(),
};

const config = {
  ...loadedConfig,
  // the following two only apply the 'endpoints' config
  ...envs.production,
  ...envConfig,
  DYNAMIC_URL_PATH: "realtors",
};

module.exports = { config, envConfig };
